import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";
import { MakeEmptyFieldNull } from "../utils/emptyToNull";

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- form values from different sections have varied shapes
type PublishStateType = Record<string, any> | null;

const PUBLISH_STATE_QUERY_KEY = "publish-state";

/**
 * Reads the current publish state from the React Query cache.
 * Used by the header and side nav to validate on the fly.
 */
export const usePublishState = (productId: string): PublishStateType => {
	const { data } = useQuery<PublishStateType>({
		queryKey: [PUBLISH_STATE_QUERY_KEY, productId],
		queryFn: () => null,
		enabled: false,
		staleTime: Number.POSITIVE_INFINITY,
	});
	return data ?? null;
};

/**
 * Returns a stable setter that writes form data into the React Query cache.
 * Used by form tabs to push their current values.
 */
export const useSetPublishState = (productId: string) => {
	const queryClient = useQueryClient();
	return useCallback(
		(data: PublishStateType) => {
			queryClient.setQueryData<PublishStateType>(
				[PUBLISH_STATE_QUERY_KEY, productId],
				data ? MakeEmptyFieldNull(data) : null,
			);
		},
		[queryClient, productId],
	);
};
